// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedFaqsRouteImport } from './routes/_authed/faqs'
import { Route as AuthedLeaderboardRouteImport } from './routes/_authed/leaderboard'
import { Route as AuthedSuperRouteImport } from './routes/_authed/super'
import { Route as AuthedAdminMembersRouteImport } from './routes/_authed/admin/members'
import { Route as AuthedAdminUsageStatsRouteImport } from './routes/_authed/admin/usage-stats'
import { Route as AuthedIntegrationsClaudeCodeRouteImport } from './routes/_authed/integrations/claude-code'
import { Route as AuthedIntegrationsCursorRouteImport } from './routes/_authed/integrations/cursor'
import { Route as AuthedIntegrationsJetbrainsRouteImport } from './routes/_authed/integrations/jetbrains'
import { Route as AuthedIntegrationsOpencodeRouteImport } from './routes/_authed/integrations/opencode'
import { Route as AuthedSuperDebuggingRouteImport } from './routes/_authed/super/debugging'
import { Route as AuthedSuperSystemRouteImport } from './routes/_authed/super/system'
import { Route as AuthedAdminMembersIndexRouteImport } from './routes/_authed/admin/members.index'
import { Route as AuthedAdminMembersUserIdRouteImport } from './routes/_authed/admin/members.$userId'

const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthedIndexRoute = AuthedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedRoute
          })
const AuthedAdminRoute = AuthedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedRoute
          })
const AuthedFaqsRoute = AuthedFaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => AuthedRoute
          })
const AuthedLeaderboardRoute = AuthedLeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => AuthedRoute
          })
const AuthedSuperRoute = AuthedSuperRouteImport.update({
            id: '/super',path: '/super',getParentRoute: () => AuthedRoute
          })
const AuthedAdminMembersRoute = AuthedAdminMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminUsageStatsRoute = AuthedAdminUsageStatsRouteImport.update({
            id: '/usage-stats',path: '/usage-stats',getParentRoute: () => AuthedAdminRoute
          })
const AuthedIntegrationsClaudeCodeRoute = AuthedIntegrationsClaudeCodeRouteImport.update({
            id: '/integrations/claude-code',path: '/integrations/claude-code',getParentRoute: () => AuthedRoute
          })
const AuthedIntegrationsCursorRoute = AuthedIntegrationsCursorRouteImport.update({
            id: '/integrations/cursor',path: '/integrations/cursor',getParentRoute: () => AuthedRoute
          })
const AuthedIntegrationsJetbrainsRoute = AuthedIntegrationsJetbrainsRouteImport.update({
            id: '/integrations/jetbrains',path: '/integrations/jetbrains',getParentRoute: () => AuthedRoute
          })
const AuthedIntegrationsOpencodeRoute = AuthedIntegrationsOpencodeRouteImport.update({
            id: '/integrations/opencode',path: '/integrations/opencode',getParentRoute: () => AuthedRoute
          })
const AuthedSuperDebuggingRoute = AuthedSuperDebuggingRouteImport.update({
            id: '/debugging',path: '/debugging',getParentRoute: () => AuthedSuperRoute
          })
const AuthedSuperSystemRoute = AuthedSuperSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => AuthedSuperRoute
          })
const AuthedAdminMembersIndexRoute = AuthedAdminMembersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAdminMembersRoute
          })
const AuthedAdminMembersUserIdRoute = AuthedAdminMembersUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => AuthedAdminMembersRoute
          })





const AuthedAdminMembersRouteChildren = {
  AuthedAdminMembersUserIdRoute: AuthedAdminMembersUserIdRoute,AuthedAdminMembersIndexRoute: AuthedAdminMembersIndexRoute
}

const AuthedAdminMembersRouteWithChildren = AuthedAdminMembersRoute._addFileChildren(AuthedAdminMembersRouteChildren)



const AuthedAdminRouteChildren = {
  AuthedAdminMembersRoute: AuthedAdminMembersRouteWithChildren,AuthedAdminUsageStatsRoute: AuthedAdminUsageStatsRoute
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(AuthedAdminRouteChildren)




const AuthedSuperRouteChildren = {
  AuthedSuperDebuggingRoute: AuthedSuperDebuggingRoute,AuthedSuperSystemRoute: AuthedSuperSystemRoute
}

const AuthedSuperRouteWithChildren = AuthedSuperRoute._addFileChildren(AuthedSuperRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,AuthedFaqsRoute: AuthedFaqsRoute,AuthedLeaderboardRoute: AuthedLeaderboardRoute,AuthedSuperRoute: AuthedSuperRouteWithChildren,AuthedIndexRoute: AuthedIndexRoute,AuthedIntegrationsClaudeCodeRoute: AuthedIntegrationsClaudeCodeRoute,AuthedIntegrationsCursorRoute: AuthedIntegrationsCursorRoute,AuthedIntegrationsJetbrainsRoute: AuthedIntegrationsJetbrainsRoute,AuthedIntegrationsOpencodeRoute: AuthedIntegrationsOpencodeRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)